import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import { consultarMaestroTransaccionesSat } from "../../../general/modulos/maestrosActions";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import { FiltroConsultaHistorico, RespuestaTSAT } from "../modelo/ReporteHistoricoModelo";
import NumericInput from "../../../general/componentes/NumericInput";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import { FiltrosTransaccion } from "../../config_general/modelo/FiltrosPorTransaccion";
import TextoInput from "../../../general/componentes/TextoInput";
import { consultarHistoricoRespuesta, descargarXLSHistorico } from "../modulos/historicoRespuestaActions";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { TipoConsulta } from "../modelo/TipoConsulta";
import TablaRespuestasTSAT from "./TablaRespuestasTSAT";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import {
    codigoCentroTrabajo, codigoSede, consecutivo, documentoEmpleado, documentoEmpleador,
    poliza, servicio, tipoConsultaHistorico, tipoDocumentoEmpleado, tipoDocumentoEmpleador
} from "../../config_general/modelo/TextosAyuda";

class FiltrosReporteHistorico extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.consultarParametrosInicio();

        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }
    }

    render() {
        const { datosRespuesta, estado, paginas, tamanoPagina, paginaActual } = this.props;

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Histórico Envío SAT</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta histórico</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Tipo de Transacción</label>
                                                <TextoAyuda texto={servicio} />
                                                <TiposTransacciones name={"tipoTransaccion"} gestionables />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoConsulta">Consultar por:</label>
                                                <TextoAyuda texto={tipoConsultaHistorico} />
                                                <TextoInputSelector name="tipoConsulta" maestro={this.listarTipoConsulta()} />
                                                {errors.tipoConsulta &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoConsulta}</span>
                                                    </div>
                                                }
                                            </Col>
                                            {
                                                values.tipoConsulta &&
                                                this.renderOpcionesConsulta(Number(values.tipoConsulta.value))
                                            }
                                        </Row>
                                        {
                                            this.renderFiltroPorTransaccion(Number(values.tipoTransaccion))
                                        }
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {!(submitting || invalid) &&
                                                        <a className="btns btn-success" onClick={() => this.descargarXLSHistorico(values)}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderTablaRespuestasTSAT(datosRespuesta, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderOpcionesConsulta(codigoConsulta: number) {
        switch (codigoConsulta) {
            case 1:
                return (
                    <Col sm={3}>
                        <label htmlFor="numeroPoliza">Póliza</label>
                        <TextoAyuda texto={poliza} />
                        <NumericInput name="numeroPoliza" />
                    </Col>
                );
            case 2:
                return (
                    <div>
                        <Col sm={3}>
                            <label htmlFor="tipoDocumentoEmpleador">Tipo Documento Empleador</label>
                            <TextoAyuda texto={tipoDocumentoEmpleador} />
                            <TipoIdentificacion name="tipoDocumentoEmpleador" />
                        </Col>
                        <Col sm={3}>
                            <label htmlFor="documentoEmpleador">Documento Empleador</label>
                            <TextoAyuda texto={documentoEmpleador} />
                            <NumericInput name="documentoEmpleador" placeholder="Ingrese un documento" />
                        </Col>
                    </div>
                );
            case 3:
                return (
                    <Col sm={3}>
                        <label htmlFor="consecutivo">Consecutivo</label>
                        <TextoAyuda texto={consecutivo} />
                        <NumericInput name="consecutivo" />
                    </Col>
                );
            default:
                return false;
        }
    }

    renderFiltroPorTransaccion(tipoTransaccion: number) {
        let sede, centroTrabajo, dniAfiliado;

        if (FiltrosTransaccion.sedes.find(t => t === tipoTransaccion)) {
            sede = (
                <Col sm={3}>
                    <label htmlFor="codigoSede">Sede</label>
                    <TextoAyuda texto={codigoSede} />
                    <TextoInput name="codigoSede" placeholder="Ingrese código de la Sede" maxLength={10} />
                </Col>
            );
        }
        if (FiltrosTransaccion.centroTrabajo.find(t => t === tipoTransaccion)) {
            centroTrabajo = (
                <Col sm={3}>
                    <label htmlFor="codigoCentroT">Centro Trabajo</label>
                    <TextoAyuda texto={codigoCentroTrabajo} />
                    <TextoInput name="codigoCentroT" placeholder="Ingrese código del Centro" maxLength={10} />
                </Col>
            );
        }
        if (FiltrosTransaccion.dniAfiliado.find(t => t === tipoTransaccion)) {
            dniAfiliado = (
                <div>
                    <Col sm={3}>
                        <label htmlFor="tipoDocumentoEmpleado">Tipo Documento Empleado</label>
                        <TextoAyuda texto={tipoDocumentoEmpleado} />
                        <TipoIdentificacion name="tipoDocumentoEmpleado" />
                    </Col>
                    <Col sm={3}>
                        <label htmlFor="documentoEmpleado">Documento Empleado</label>
                        <TextoAyuda texto={documentoEmpleado} />
                        <NumericInput name="documentoEmpleado" placeholder="Ingrese un documento" />
                    </Col>
                </div>
            );
        }

        return (
            <Row className={"form-group"}>
                {sede}
                {centroTrabajo}
                {dniAfiliado}
            </Row>
        );

    }

    renderTablaRespuestasTSAT(datosRespuesta: Array<RespuestaTSAT>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!datosRespuesta || !datosRespuesta.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado parámetros"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaRespuestasTSAT
                                respuestasTSAT={datosRespuesta}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    filtros(): FiltroConsultaHistorico {
        return {
            tipoTransaccion: this.state.tipoTransaccion,
            dniEmpleador: this.state.dniEmpleador,
            poliza: this.state.poliza,
            consecutivo: this.state.consecutivo,
            codigoSede: this.state.codigoSede,
            codigoCentroTrabajo: this.state.codigoCentroT,
            dniEmpleado: this.state.dniEmpleado
        };
    }

    consultaPaginada = (filtro: FiltroConsultaHistorico) => {
        this.props.dispatch(consultarHistoricoRespuesta(filtro));
    };

    descargarXLSHistorico = (values: any) => {
        if (this.props.estadoDescarga !== REQUEST.PENDING) {
            const filtro = this.obtenerValores(values);
            this.props.dispatch(descargarXLSHistorico(filtro));
        }
    };

    onSubmit = (values: any) => {
        this.props.dispatch(consultarHistoricoRespuesta(this.obtenerValores(values)));
    };

    consultarParametrosInicio = () => {
        const tipoTransaccion = Number(new URLSearchParams(this.props.location.search).get("codigoServicio"));
        const consecutivo = Number(new URLSearchParams(this.props.location.search).get("consecutivo"));
        const dni = new URLSearchParams(this.props.location.search).get("dni");

        if (tipoTransaccion && (consecutivo || dni)) {
            const filtro: FiltroConsultaHistorico = {
                tipoTransaccion: tipoTransaccion,
                consecutivo: consecutivo,
                dniEmpleador: dni,
                tamanoPagina: 10,
                paginaActual: 0
            };

            this.setState({
                tipoTransaccion: tipoTransaccion,
                consecutivo: consecutivo,
                dniEmpleador: dni,
                filtro: filtro
            });

            this.props.dispatch(consultarHistoricoRespuesta(filtro));
        }
    };

    obtenerValores = (values: any) => {

        const tipoConsulta = Number(values.tipoConsulta.value);
        const tipoTransaccion = values.tipoTransaccion ? Number(values.tipoTransaccion) : undefined;
        const numeroPoliza = tipoConsulta === 1 && values.numeroPoliza ? values.numeroPoliza.valueOf() : undefined;
        const dniEmpleador = tipoConsulta === 2 && values.tipoDocumentoEmpleador && values.documentoEmpleador ?
            (values.tipoDocumentoEmpleador + values.documentoEmpleador) : undefined;
        const consecutivo = tipoConsulta === 3 && values.consecutivo ? values.consecutivo.valueOf() : undefined;
        const codigoSede = values.codigoSede ? values.codigoSede.valueOf() : undefined;
        const codigoCentroT = values.codigoCentroT ? values.codigoCentroT.valueOf() : undefined;
        const dniEmpleado = (values.tipoDocumentoEmpleado && values.documentoEmpleado) ?
            (values.tipoDocumentoEmpleado + values.documentoEmpleado) : undefined;

        const filtro: FiltroConsultaHistorico = {
            tipoTransaccion: tipoTransaccion,
            dniEmpleador: dniEmpleador,
            poliza: numeroPoliza,
            consecutivo: consecutivo,
            codigoSede: codigoSede,
            codigoCentroTrabajo: codigoCentroT,
            dniEmpleado: dniEmpleado,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            tipoTransaccion: tipoTransaccion,
            dniEmpleador: dniEmpleador,
            poliza: numeroPoliza,
            consecutivo: consecutivo,
            codigoSede: codigoSede,
            codigoCentroTrabajo: codigoCentroT,
            dniEmpleado: dniEmpleado,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            tipoTransaccion: undefined,
            tipoConsulta: undefined,
            tipoDocumentoEmpleador: undefined,
            documentoEmpleador: undefined,
            numeroPoliza: undefined,
            consecutivo: undefined
        };

        if (!values.tipoTransaccion)
            errors.tipoTransaccion = "Por favor seleccione una de las opciones";

        if (values.tipoTransaccion && !values.tipoConsulta)
            errors.tipoConsulta = "Por favor seleccione una de las opciones";

        if (values.tipoConsulta) {
            if (values.tipoConsulta.value === 1 && !values.numeroPoliza)
                errors.numeroPoliza = "Ingrese la póliza.";

            if (values.tipoConsulta.value === 2 && !values.tipoDocumentoEmpleador)
                errors.tipoDocumentoEmpleador = "Seleccione el tipo de documento.";

            if (values.tipoConsulta.value === 2 && values.tipoDocumentoEmpleador && !values.documentoEmpleador)
                errors.documentoEmpleador = "Ingrese el numero de documento.";

            if (values.tipoConsulta.value === 3 && !values.consecutivo)
                errors.consecutivo = "Ingrese el numero del consecutivo.";
        }

        return errors;
    };

    listarTipoConsulta = () => {
        return [].concat(
            TipoConsulta.map(value => ({
                value: value.codigo,
                label: value.opcion
            })
            ));
    }

}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        estado: R.pathOr([], ["reporte_historico_rta", "estado"])(store),
        estadoDescarga: R.pathOr([], ["reporte_historico_rta", "estadoDescarga"])(store),
        datosRespuesta: R.pathOr([], ["reporte_historico_rta", "datosRespuesta"])(store),
        paginas: R.pathOr([], ["reporte_historico_rta", "paginas"])(store),
        paginaActual: R.pathOr([], ["reporte_historico_rta", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["reporte_historico_rta", "tamanoPagina"])(store),
        totalParametrosConsulta: R.pathOr([], ["reporte_historico_rta", "totalParametrosConsulta"])(store)
    };
})(FiltrosReporteHistorico);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_historico_rta/componentes/FiltrosReporteHistorico.tsx